import { render, staticRenderFns } from "./ListSuplliesNotAllow.vue?vue&type=template&id=f3408df4"
import script from "./ListSuplliesNotAllow.vue?vue&type=script&lang=js"
export * from "./ListSuplliesNotAllow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports